import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import QueryStringNavigate from '../QueryStringNavigate';
import './style.scss';

export const WPCommunitiesInterlinking = ({ communityLinks }) => {
  const { t } = useTranslation(['interlinking']);
  const municipality = t('interlinking.province');

  return (
    <div className="communitiesInterlinking">
      <div className="links">
        {communityLinks &&
          Object.keys(communityLinks).map((community) => (
            <div className="interlinkingGroup">
              <div className="interlinkingGroupTitle">{community}</div>
              <div className="interlinkingGroupLinks">
                {communityLinks[community].map(({ slug, uri, title }) => (
                  <QueryStringNavigate
                    className="interlinkingItem"
                    key={slug}
                    path={uri}
                  >
                    {title}
                  </QueryStringNavigate>
                ))}
              </div>
            </div>
          ))}
      </div>
      <p className="footCTA">
        {t('interlinking.copyCTA', { municipality })}{' '}
        <QueryStringNavigate className="labelCTALink" path="/contacto/">
          {t('interlinking.labelCTALink')}
        </QueryStringNavigate>
      </p>
    </div>
  );
};
